import React, { useContext, useEffect, useState } from 'react'
import { Link } from '../../../utils/helpers'
import { ReactComponent as Logo } from '../../../assets/icons/logo.svg'
import HeaderLinks from './HeaderLinks'
import Button from '../../../components/Button/Button'
import { Color, Direction } from '../../../utils/constants'
import { FormattedMessage } from 'react-intl'
import CareersContext from '../../../templates/Careers/CareersContext'
import MobileMenuButton from './MobileMenuButton'
import { useIsMobile } from '../../../utils/helpers'
import { twMerge } from 'tailwind-merge'

interface HeaderBodyProps {
  colors: {
    text: string
    fill: string
    color: Color
  }
  isMobileMenuOpen: boolean
  setIsMobileMenuOpen: (isOpen: boolean) => void
  separatorBottomPosition?: number
}

const HeaderBody = ({ colors, isMobileMenuOpen, setIsMobileMenuOpen }: HeaderBodyProps) => {
    const { openings } = useContext(CareersContext)
    const [separatorBottom, setSeparatorBottom] = useState(0)
    const isMobile = useIsMobile()

    useEffect(() => {
        const separator = document.querySelector('#header-separator')
        setSeparatorBottom(separator?.getBoundingClientRect().bottom ?? 0)
    }, [isMobileMenuOpen])

    return (
        <div className='relative z-40'>
            {isMobile ? (
                <nav>
                    <div className='flex items-center justify-between'>
                        <Link to={'/'} className='relative z-30'>
                            <Logo className={colors.fill} />
                        </Link>
                        <MobileMenuButton
                            isOpen={isMobileMenuOpen}
                            setIsOpen={setIsMobileMenuOpen}
                            color={colors.color}
                        />
                    </div>
                    {isMobileMenuOpen && (
                        <div
                            className='absolute flex flex-col gap-y-10 top-0 text-white'
                            style={{ paddingTop: separatorBottom + 20 }}
                        >
                            <HeaderLinks isMobile color={colors.color} careerOpeningsCount={openings.length} />
                        </div>
                    )}
                </nav>
            ) : (
                <nav
                    className={twMerge('flex justify-between items-center z-40', colors.text, colors.fill)}
                >
                    <Link to={'/'} className='relative z-30'>
                        <Logo className={colors.fill} />
                    </Link>
                    <div className='flex items-center gap-x-10'>
                        <HeaderLinks color={colors.color} careerOpeningsCount={openings.length} />
                        <Link to='/contact' className='relative z-30'>
                            <Button buttonColor={colors.color} type='button' chevron={Direction.RIGHT}>
                                <FormattedMessage id={'page.contactUs'}>
                                    {(value) => <span className='header-link'>{value}</span>}
                                </FormattedMessage>
                            </Button>
                        </Link>
                    </div>
                </nav>
            )}
        </div>
    )
}

export default HeaderBody
